import React, { memo } from "react";
import LoadBudget from "../budget/loadBudget";

const PresupuestoCarga = () => {
  return <LoadBudget />;
};

export default PresupuestoCarga;
